import { getGlobal } from "../lib/get-global";
import { generateRandomString } from "../lib/random";
import { MetadataPlugin } from "./metadata";

export const createSessionIdPlugin: MetadataPlugin<string> = function () {
  const globalThis = getGlobal();

  if (
    typeof globalThis === "undefined" ||
    typeof sessionStorage === "undefined"
  ) {
    return {
      getValue() {
        return {};
      },
    };
  }

  const SESSION_ID_KEY = "spindl_session_id";

  let sessionId = sessionStorage.getItem(SESSION_ID_KEY) || "";

  if (!sessionId) {
    sessionId = generateRandomString();
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  function getValue() {
    return { sessionId };
  }

  return {
    getValue,
  };
};
